const uiColors = {
  overlay: {
    default: 'rgba(5, 6, 75, 0.9)',
  },
  primary: {
    default: 'rgba(125, 74, 213, 0.5)',
    hover: 'rgba(140, 81, 242, 0.7)',
    pressed: 'rgba(85, 28, 184, 0.5)',
    disabled: 'rgba(125, 74, 213, 0.2)',
  },
  secondary: {
    default: '#FF2F6D',
    hover: '#FF6594',
    pressed: '#E20749',
  },
  toggled: {
    default: 'rgba(140, 81, 242, 0.7)',
  }
};

const uiConfig = {
  H: {
    colors: uiColors,
    offsets: {
      right_panel: { top: 0, left: -11 },
      bottom_panel: { top: 0, left: 76 },
    },
  },

  V: {
    colors: uiColors,
    offsets: {
      top: 0,
      left: 0,
      tournaments_panel: {
        top: 150,
        left: -590,
      },
    },
  }
};

export {
  uiConfig,
}
